module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box"
  }, [(_vm.catelist.length > 0) ? _c('div', {
    staticClass: "row4"
  }, [_c('img', {
    class: _vm.currentIndex == 1 ? 'current' : '',
    attrs: {
      "src": _vm.catelist[0].pic_url
    },
    on: {
      "click": function($event) {
        return _vm.setCurrent(1)
      }
    }
  }), _vm._v(" "), _c('img', {
    class: _vm.currentIndex == 2 ? 'current' : '',
    attrs: {
      "src": _vm.catelist[1].pic_url
    },
    on: {
      "click": function($event) {
        return _vm.setCurrent(2)
      }
    }
  }), _vm._v(" "), _c('img', {
    class: _vm.currentIndex == 3 ? 'current' : '',
    attrs: {
      "src": _vm.catelist[2].pic_url
    },
    on: {
      "click": function($event) {
        return _vm.setCurrent(3)
      }
    }
  }), _vm._v(" "), _c('img', {
    class: _vm.currentIndex == 4 ? 'current' : '',
    attrs: {
      "src": _vm.catelist[3].pic_url
    },
    on: {
      "click": function($event) {
        return _vm.setCurrent(4)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.catelist), function(row, i) {
    return (i > 3) ? _c('img', {
      key: i,
      class: _vm.currentIndex == row.id ? 'current' : '',
      attrs: {
        "src": row.pic_url
      },
      on: {
        "click": function($event) {
          return _vm.setCurrent(row.id)
        }
      }
    }) : _vm._e()
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'CbaApplyFormBasic',
        query: {
          station_id: 5
        }
      }),
      expression: "{ name: 'CbaApplyFormBasic', query: { station_id: 5 } }"
    }],
    attrs: {
      "src": "https://bc2026.oss-ap-southeast-1.aliyuncs.com/uploader/000/user-xxx/vc-upload-1607561416269-8.png"
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'CbaApplyFormBasic',
        query: {
          station_id: 6
        }
      }),
      expression: "{ name: 'CbaApplyFormBasic', query: { station_id: 6 } }"
    }],
    attrs: {
      "src": "https://bc2026.oss-ap-southeast-1.aliyuncs.com/uploader/000/user-xxx/vc-upload-1607561416269-4.png"
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'CbaApplyFormBasic',
        query: {
          station_id: 4
        }
      }),
      expression: "{ name: 'CbaApplyFormBasic', query: { station_id: 4 } }"
    }],
    attrs: {
      "src": "https://bc2026.oss-ap-southeast-1.aliyuncs.com/uploader/000/user-xxx/vc-upload-1607561416269-6.png"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 2) : _vm._e(), _vm._v(" "), _c('div', [_c('van-cell', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'HuiyiApplyList'
      }),
      expression: "{ name: 'HuiyiApplyList' }"
    }],
    attrs: {
      "is-link": "",
      "title": "我的会议培训",
      "label": '我报名的会议培训' + _vm.row.huiyi_join_count + '场'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [(_vm.row.huiyi_count) ? _c('div', {
          staticClass: "badge"
        }, [_vm._v("\n            " + _vm._s(_vm.row.huiyi_count) + "\n          ")]) : _vm._e()]
      },
      proxy: true
    }])
  })], 1), _vm._v(" "), (false) ? _c('van-notice-bar', {
    attrs: {
      "wrapable": "",
      "scrollable": false,
      "text": "请向下滑查看更多，请根据自己所属身份报名对应的培训（不得跨省报名）。"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentIndex == 0) ? _c('div', [(_vm.row.group_list.length > 0) ? _c('van-collapse', {
    model: {
      value: (_vm.huiyiAcitiveCs),
      callback: function($$v) {
        _vm.huiyiAcitiveCs = $$v
      },
      expression: "huiyiAcitiveCs"
    }
  }, _vm._l((_vm.row.group_list), function(group, gindex) {
    return _c('van-collapse-item', {
      key: gindex,
      attrs: {
        "title": group.name,
        "name": gindex + 1
      }
    }, [_c('van-notice-bar', {
      staticStyle: {
        "margin-bottom": "10px"
      },
      attrs: {
        "wrapable": "",
        "scrollable": false,
        "text": group.desc
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "train-box flex-between",
      staticStyle: {
        "flex-wrap": "wrap"
      }
    }, _vm._l((group.list), function(row, index) {
      return _c('div', {
        directives: [{
          name: "rblink",
          rawName: "v-rblink",
          value: ({
            name: 'HuiyiApplyFormStep1',
            query: {
              saiqu_id: row.id
            },
          }),
          expression: "{\n                name: 'HuiyiApplyFormStep1',\n                query: { saiqu_id: row.id },\n              }"
        }],
        key: index,
        staticClass: "train-items"
      }, [_c('div', {
        staticClass: "train-items-top items-top1",
        style: ('background-image: linear-gradient(to right, #' +
          row.color[0] +
          ' , #' +
          row.color[1] +
          ');')
      }, [_c('div', [_c('div', {
        staticClass: "train-items-top-city"
      }, [_vm._v(_vm._s(row.location))]), _vm._v(" "), _c('div', {
        staticClass: "train-items-top-time"
      }, [_vm._v(_vm._s(row.date_str))])])]), _vm._v(" "), _c('div', {
        staticClass: "train-items-title"
      }, [_vm._v(_vm._s(row.name))]), _vm._v(" "), (!row.is_pass) ? _c('div', {
        staticClass: "flex-between"
      }, [_c('div', {
        staticClass: "train-items-time"
      }, [_vm._v(_vm._s(row.startdate))]), _vm._v(" "), _c('div', {
        staticClass: "train-items-address"
      }, [_vm._v("\n                  " + _vm._s(row.province) + "·" + _vm._s(row.city) + "\n                ")])]) : _c('div', {
        staticStyle: {
          "color": "#ed6a0c"
        }
      }, [_vm._v("\n                报名人数已满，请等待下一期\n              ")])])
    }), 0)], 1)
  }), 1) : _vm._e()], 1) : (
    _vm.currentIndex == 1 ||
    _vm.currentIndex == 2 ||
    _vm.currentIndex == 3 ||
    _vm.currentIndex == 4
  ) ? _c('div', [(_vm.huiyiList.length > 0) ? _c('div', {
    staticClass: "more-box",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "train-box flex-between",
    staticStyle: {
      "flex-wrap": "wrap"
    }
  }, _vm._l((_vm.huiyiList), function(row, index) {
    return _c('div', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'HuiyiApplyFormStep1',
          query: {
            saiqu_id: row.id
          },
        }),
        expression: "{\n              name: 'HuiyiApplyFormStep1',\n              query: { saiqu_id: row.id },\n            }"
      }],
      key: index,
      staticClass: "train-items"
    }, [_c('div', {
      staticClass: "train-items-top items-top1",
      style: ('background-image: linear-gradient(to right, #' +
        row.color[0] +
        ' , #' +
        row.color[1] +
        ');')
    }, [_c('div', [_c('div', {
      staticClass: "train-items-top-city"
    }, [_vm._v(_vm._s(row.location))]), _vm._v(" "), _c('div', {
      staticClass: "train-items-top-time"
    }, [_vm._v(_vm._s(row.date_str))])])]), _vm._v(" "), _c('div', {
      staticClass: "train-items-title"
    }, [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('div', {
      staticClass: "flex-between"
    }, [_c('div', {
      staticClass: "train-items-time"
    }, [_vm._v(_vm._s(row.startdate))]), _vm._v(" "), _c('div', {
      staticClass: "train-items-address"
    }, [_vm._v("\n                " + _vm._s(row.province) + "·" + _vm._s(row.city) + "\n              ")])])])
  }), 0)]) : _c('van-empty', {
    attrs: {
      "description": "暂无场次"
    }
  })], 1) : (_vm.currentIndex > 10) ? _c('div', [(_vm.news_list.length > 0) ? _c('div', {
    staticClass: "box"
  }, _vm._l((_vm.news_list), function(row, i) {
    return _c('div', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'NewsDetail',
          query: {
            id: row.id
          }
        }),
        expression: "{ name: 'NewsDetail', query: { id: row.id } }"
      }],
      key: i
    }, [(row.pics.length == 0) ? _c('NewsItem1', {
      attrs: {
        "row": row
      }
    }) : _vm._e(), _vm._v(" "), (row.pics.length == 1) ? _c('NewsItem2', {
      attrs: {
        "row": row
      }
    }) : _vm._e(), _vm._v(" "), (false) ? _c('NewsItem3') : _vm._e(), _vm._v(" "), (row.pics.length > 1) ? _c('NewsItem4', {
      attrs: {
        "row": row
      }
    }) : _vm._e()], 1)
  }), 0) : _c('van-empty', {
    attrs: {
      "description": "暂无内容"
    }
  })], 1) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.row.doing.length > 0),
      expression: "row.doing.length > 0"
    }],
    staticClass: "more-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-solid"
  }), _vm._v(" "), _c('div', {
    staticClass: "train-box flex-between",
    staticStyle: {
      "flex-wrap": "wrap"
    }
  }, _vm._l((_vm.row.doing), function(row, index) {
    return _c('div', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'HuiyiPcStep1',
          query: {
            saiqu_id: row.id
          },
        }),
        expression: "{\n            name: 'HuiyiPcStep1',\n            query: { saiqu_id: row.id },\n          }"
      }],
      key: index,
      staticClass: "train-items"
    }, [_c('div', {
      staticClass: "train-items-top items-top1",
      style: ('background-image: linear-gradient(to right, #' +
        row.color[0] +
        ' , #' +
        row.color[1] +
        ');')
    }, [_c('div', [_c('div', {
      staticClass: "train-items-top-city"
    }, [_vm._v(_vm._s(row.location))]), _vm._v(" "), _c('div', {
      staticClass: "train-items-top-time"
    }, [_vm._v(_vm._s(row.date_str))])])]), _vm._v(" "), _c('div', {
      staticClass: "train-items-title"
    }, [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('div', {
      staticClass: "flex-between"
    }, [_c('div', {
      staticClass: "train-items-time"
    }, [_vm._v(_vm._s(row.startdate))]), _vm._v(" "), _c('div', {
      staticClass: "train-items-address"
    }, [_vm._v("\n              " + _vm._s(row.province) + "·" + _vm._s(row.city) + "\n            ")])])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "more-active"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "solid solid2"
  }), _vm._v(" "), _c('span', {
    staticClass: "more-title"
  }, [_vm._v("正在报名 ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-571e3b5c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/huiyi/HuiyiIndex.vue
// module id = 1416
// module chunks = 0